import { render, staticRenderFns } from "./Fornecedores.vue?vue&type=template&id=459a4c4b"
import script from "./Fornecedores.vue?vue&type=script&lang=js"
export * from "./Fornecedores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports